import React from 'react';

import {Accordion, AccordionDetails, AccordionSummary, Box, Paper, Stack, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const ScopeCard = () => {
  const careScope = {
    canDo: [
      {
        title: translate('startstep.ScopeCard.CanDoCompanionshipTitle'),
        description: translate('startstep.ScopeCard.CanDoCompanionshipDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CanDoMobilityTitle'),
        description: translate('startstep.ScopeCard.CanDoMobilityDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CanDoPersonalCareTitle'),
        description: translate('startstep.ScopeCard.CanDoPersonalCareDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CanDoHomeSupportTitle'),
        description: translate('startstep.ScopeCard.CanDoHomeSupportDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CanDoNutritionTitle'),
        description: translate('startstep.ScopeCard.CanDoNutritionDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CanDoMedicationRemindersTitle'),
        description: translate('startstep.ScopeCard.CanDoMedicationRemindersDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CanDoTransportationTitle'),
        description: translate('startstep.ScopeCard.CanDoTransportationDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CanDoErrandsTitle'),
        description: translate('startstep.ScopeCard.CanDoErrandsDescription'),
      },
    ],
    cannotDo: [
      {
        title: translate('startstep.ScopeCard.CannotDoMedicalProceduresTitle'),
        description: translate('startstep.ScopeCard.CannotDoMedicalProceduresDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CannotDoAssessmentsTitle'),
        description: translate('startstep.ScopeCard.CannotDoAssessmentsDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CannotDoHeavyLaborTitle'),
        description: translate('startstep.ScopeCard.CannotDoHeavyLaborDescription'),
      },
      {
        title: translate('startstep.ScopeCard.CannotDoProfessionalServicesTitle'),
        description: translate('startstep.ScopeCard.CannotDoProfessionalServicesDescription'),
      },
    ],
  };

  return (
    <Paper sx={{padding: '32px', borderRadius: '24px', boxShadow: 'none'}}>
      <Stack sx={{gap: '32px'}}>
        <Stack sx={{gap: '20px'}}>
          <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
            <Translate expression={'startstep.ScopeCard.Title'} />
          </Typography>
          <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
            <Translate expression={'startstep.ScopeCard.DescriptionBeforeHighlight'} />{' '}
            <span style={{fontWeight: 600, color: '#2D2925'}}><Translate expression={'startstep.ScopeCard.DescriptionHighlight'} /></span>{' '}
            <Translate expression={'startstep.ScopeCard.DescriptionMiddle'} />{' '}
            <Translate expression={'startstep.ScopeCard.DescriptionTerm'} />
          </Typography>
        </Stack>

        <Stack sx={{gap: '32px'}}>
          {
            [
              {title: translate('startstep.ScopeCard.CanDoTitle'), items: careScope.canDo},
              {title: translate('startstep.ScopeCard.CannotDoTitle'), items: careScope.cannotDo},
            ]
                .map((section) => (
                  <Accordion
                    key={section.title}
                    sx={{
                      'overflow': 'hidden',
                      'border': '1px solid #DED8D7',
                      'backgroundColor': 'white',
                      'boxShadow': 'none',
                      '&:before': {
                        display: 'none',
                      },
                      '& .MuiAccordionDetails-root': {
                        borderTop: '1px solid #DED8D7',
                      },
                      '& .MuiCollapse-hidden .MuiAccordionDetails-root': {
                        borderTop: 'none',
                      },
                      '&:first-of-type': {
                        borderRadius: '24px',
                      },
                      '&:last-of-type': {
                        borderRadius: '24px',
                      },
                    }}
                  >
                    <AccordionSummary
                      sx={{
                        'padding': '0 12px',
                        'backgroundColor': '#F7F2EE',
                        'flexDirection': 'row',
                        '& .MuiAccordionSummary-content': {
                          margin: '10px 0',
                          ml: 0,
                        },
                      }}
                    >
                      <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
                        {section.title}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{padding: 0}}>
                      <Stack>
                        {section.items.map((item, index) => (
                          <Box
                            key={item.title}
                            sx={{
                              gap: '4px',
                              display: 'flex',
                              flexDirection: 'column',
                              padding: '12px 20px',
                              borderBottom: index === section.items.length - 1 ? 'none' : '1px solid #EEE6E1',
                            }}
                          >
                            <Typography sx={{fontWeight: 590, fontSize: '16px', color: '#2D2925', lineHeight: '150%'}}>
                              {item.title}
                            </Typography>
                            <Typography sx={{fontWeight: 400, fontSize: '16px', color: '#2D2925A3', lineHeight: '150%'}}>
                              {item.description}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    </AccordionDetails>
                  </Accordion>
                ))
          }
        </Stack>
      </Stack>
    </Paper>
  );
};

export default React.memo(ScopeCard);
